// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"AdvantagesSection_headerWrapper__zi8p9","advantages":"AdvantagesSection_advantages__kcS6b"};